import React, { useEffect, useState } from "react";
import { api } from "../../api/client";
import "./assistantReplyFeedback.scss";

export type AssistantReply = { id: number; agent: string; notice: string; helpful: boolean | null; canRate: boolean; bookingUrl?: string };

export function AssistantReplyFeedback({ reply, taskId, messageId }: { reply?: AssistantReply; taskId: string; messageId: number }) {
    const [helpful, setHelpful] = useState<boolean | null>(reply?.helpful ?? null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    useEffect(() => { setHelpful(reply?.helpful ?? null); }, [reply?.id, reply?.helpful]);
    if (!reply) return null;
    const rate = async (value: boolean) => {
        if (saving) return;
        setSaving(true); setError("");
        try {
            await api.post(`/api/gateway/tasks/${taskId}/messages/${messageId}/ai-feedback`, { helpful: value });
            setHelpful(value);
        } catch (_) { setError("Не удалось сохранить оценку. Попробуйте ещё раз."); }
        finally { setSaving(false); }
    };
    return <aside className="ticket-assistant-feedback" aria-label="Оценка ответа ИИ поддержки">
        <strong>ИИ поддержка</strong><p>{reply.notice}</p>
        {/^https:\/\/widget2\.chio-chio\.ru\/city\/[1-9]\d*\/[1-9]\d*$/.test(reply.bookingUrl || "") && <p><a href={reply.bookingUrl} target="_blank" rel="noreferrer">Открыть онлайн-запись салона</a></p>}
        {reply.canRate && <div>
            <button type="button" aria-pressed={helpful === true} disabled={saving} onClick={() => rate(true)}>Ответ был полезен</button>
            <button type="button" aria-pressed={helpful === false} disabled={saving} onClick={() => rate(false)}>Ответ не был полезен</button>
        </div>}
        <span role="status">{saving ? "Сохраняем оценку…" : helpful !== null ? "Спасибо! Ваша оценка сохранена." : ""}</span>
        {error && <span role="alert">{error}</span>}
    </aside>;
}
